import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "../AxiosClient";

export const studyMatrialsAsync = createAsyncThunk(
  "web/studyMatrials",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/studyMatrials`, [], toolkit);
  }
);

export const materialSubjectChapterCountAsync = createAsyncThunk(
  "user/materialSubjectChapterCount",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/materialSubjectChapterCount`,
      payload,
      toolkit
    );
  }
);

export const materialUserChapterBySubjectIdAsync = createAsyncThunk(
  "user/materialUserChapterBySubjectId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/materialUserChapterBySubjectId`,
      payload,
      toolkit
    );
  }
);

export const userStudyMatrialsAsync = createAsyncThunk(
  "user/userStudyMatrials",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/userStudyMatrials?subjectId=${payload?.subjectId || ""}&chapterId=${
        payload?.chapterId || ""
      }&type=${payload?.type || ""}&materialId=${
        payload?.materialId || ""
      }&materialType=${payload?.materialType || ""}`,
      payload,
      toolkit
    );
  }
);
